/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Table } from "react-bootstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { FiDownload } from "react-icons/fi";
import { Helmet } from "react-helmet";

// Components
import { validate, validateSpecificDates } from "common/Regex";
import Loader from "../../../components/Loader";
import Layout from "../../../components/layout/Layout";
import ApplyCertificateForm from "./apply-employee-certificate-form";
import { taxIncomeService } from "common/StringUtils";
import { dataTable, mobileScroll } from "common/FunctionUtils";
import DownloadCertificateModal from "../employer-certificate/download-files/main";
import { LOCALES } from "common/constants";

const EmployerCertificates = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");

  const [orderType, setOrderType] = useState();
  const [toggleCertificate, settoggleCertificate] = useState(false);
  const [employeeCertificate, setEmployeeCertificate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  // Apply Employee Certificate Start
  const [fieldsError, setfieldsError] = useState(false);
  const [checkList, setcheckList] = useState({
    isStillEmployed: false,
    isFullTimehoursPerWeek: false,
    isPartTimehoursPerWeek: false,
    isVaryingHours: false,
    employeeOwnRequest: false,
    isOtherReason: false,
    isContinueWorkFrom: false,
    isUntilFurtherNotice: false,

    isContinueVariableWorkingHours: false,
    isContinueEmployeeAccepted: false,
    isTimeWorkedUntilFurtherNotice: false,
    isTeachingHours: false,
    isMonthlySalary: false,
    isWeeklySalary: false,
    isDalilySalary: false,
    isHourlySalary: false,
    isFillingWorkvaried: false,
    isSalaryInAdditional: false,
    isEmployeeWithHoliday: false,
    isEmployeeWithLivingWage: false,
    isCrossInstedofTick: false,
    isTickInCorrectly: false,
    specialInfoEmployment: false,
    isCompensationTermination: false,
  });

  const [fields, setFields] = useState({
    // 1st section
    firstName: "",
    lastName: "",
    socialSecurityNumber: "",

    // 2nd section
    employmentPeriodFrom: "",
    employmentPeriodEnd: "",
    employeePosition: "Freelancer",
    leaveAbsenceFrom: null,
    leaveAbsenceEnd: null,
    extendsIn: null,

    // 4th section
    fullTimehoursPerWeek: null,
    partTimehoursPerWeek: null,
    percentageFullTimeEmployement: null,

    // 6th section
    otherReason: null,

    // 8th section
    continueWorkFromDate: null,
    continueWorkEndDate: null,
    isContinueEmployeeAcceptedDate: null,

    // 9th section
    signature: null,
    nameClarification: null,

    // 11th
    reportedTimeFromDate: "",
    reportedTimeEndDate: "",
    teachingHours: "",

    // 12th
    salaryRefers: "",
    amountForOverTime: null,
    overTimeHours: null,
    hoursMertidFilllingTime: null,

    // 13th
    numberOfPaidHoliday: null,
    holidayPayInKroner: null,
    earnedLivingWage: null,

    // 14th
    otherInformation: null,

    // 15th
    employersDate: null,

    // 16th

    // 17th Person Info.
    userName: "",
    employerName: "Invozio LV SIA",
    streetAddress: "AHTRI 12",
    mailingAddress: "10151 Tallinn",
    organizationNumber: "5020854062",
    telephoneNumber: "010-264 88 10",

    // other Info in Text Area.
    otherInfomationEmployment: null,

    // employer Signature
    representativeCity: null,
  });

  const [firstYearDataTable, setfirstYearDataTable] = useState(dataTable());
  const [secondYearDataTable, setsecondYearDataTable] = useState(dataTable());

  const [incomeServiceFields, setincomeServiceFields] =
    useState(taxIncomeService);

  const updateCreatedDate = (startDate) => {
    const startYear = new Date(startDate).getFullYear();
    const updatedMonths = firstYearDataTable?.map((month) => ({
      ...month,
      hoursDate: `${startYear}-${month.month}-01`,
    }));
    setfirstYearDataTable(updatedMonths);
  };

  const updateCreatedDate1 = (startDate) => {
    const startYear = new Date(startDate).getFullYear();
    const updatedMonths = secondYearDataTable?.map((month) => ({
      ...month,
      hoursDate: `${startYear}-${month.month}-01`,
    }));
    setsecondYearDataTable(updatedMonths);
  };

  useEffect(() => {
    if (fields?.reportedTimeEndDate) {
      updateCreatedDate1(fields?.reportedTimeEndDate);
    }
  }, [fields?.reportedTimeEndDate]);

  useEffect(() => {
    if (fields?.reportedTimeFromDate) {
      updateCreatedDate(fields?.reportedTimeFromDate);
    }
  }, [fields?.reportedTimeFromDate]);

  const combinedArray = [...firstYearDataTable, ...secondYearDataTable];
  const tableFilterData = combinedArray.filter((item) => {
    const hoursworked = parseFloat(item.hoursworked) || 0;
    const absence = parseFloat(item.absence) || 0;
    const overtime = parseFloat(item.overtime) || 0;
    const mertidFillingTime = parseFloat(item.mertidFillingTime) || 0;
    const allZero =
      hoursworked === 0 &&
      absence === 0 &&
      overtime === 0 &&
      mertidFillingTime === 0;
    return !allZero;
  });

  const TaxserviceTableFiltered = incomeServiceFields.filter((item) => {
    const numberOfDaysWorked = parseFloat(item.numberOfDaysWorked) || 0;
    const dutyHours = parseFloat(item.dutyHours) || 0;
    const nOKMonth = parseFloat(item.nOKMonth) || 0;
    const nOKMonthAmount = parseFloat(item.nOKMonthAmount) || 0;

    const allZero =
      numberOfDaysWorked === 0 &&
      dutyHours === 0 &&
      nOKMonth === 0 &&
      nOKMonthAmount === 0;

    return !allZero;
  });

  const filteredData = tableFilterData.map((item) => {
    const newItem = {};
    for (const key in item) {
      if (key === "month") {
        newItem[key] = item[key];
      } else {
        newItem[key] = isNaN(Number(item[key])) ? item[key] : Number(item[key]);
      }
    }
    return newItem;
  });

  const filterTaxServiceIncome = TaxserviceTableFiltered.map((item) => {
    const newItem = {};
    for (const key in item) {
      if (key === "monthdate") {
        newItem[key] = item[key];
      } else {
        newItem[key] = isNaN(Number(item[key])) ? item[key] : Number(item[key]);
      }
    }
    return newItem;
  });

  const handlefirstYearDataTableChange = (index, field, value) => {
    setfirstYearDataTable((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: value,
      };

      const totalTeachingHoursFirstYear = updatedDetails.reduce(
        (acc, item) =>
          acc +
          (parseFloat(item.hoursworked) || 0) +
          (parseFloat(item.absence) || 0) +
          (parseFloat(item.overtime) || 0) +
          (parseFloat(item.mertidFillingTime) || 0),
        0
      );

      const totalTeachingHoursSecondYear = secondYearDataTable.reduce(
        (acc, item) =>
          acc +
          (parseFloat(item.hoursworked) || 0) +
          (parseFloat(item.absence) || 0) +
          (parseFloat(item.overtime) || 0) +
          (parseFloat(item.mertidFillingTime) || 0),
        0
      );

      const totalTeachingHours =
        totalTeachingHoursFirstYear + totalTeachingHoursSecondYear;

      setFields((prevFields) => ({
        ...prevFields,
        teachingHours: totalTeachingHours,
      }));
      return updatedDetails;
    });
  };

  const handleSecondYearDataTableChange = (index, field, value) => {
    setsecondYearDataTable((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: value,
      };
      const totalTeachingHoursFirstYear = firstYearDataTable.reduce(
        (acc, item) =>
          acc +
          (parseFloat(item.hoursworked) || 0) +
          (parseFloat(item.absence) || 0) +
          (parseFloat(item.overtime) || 0) +
          (parseFloat(item.mertidFillingTime) || 0),
        0
      );
      const totalTeachingHoursSecondYear = updatedDetails.reduce(
        (acc, item) =>
          acc +
          (parseFloat(item.hoursworked) || 0) +
          (parseFloat(item.absence) || 0) +
          (parseFloat(item.overtime) || 0) +
          (parseFloat(item.mertidFillingTime) || 0),
        0
      );

      const totalTeachingHours =
        totalTeachingHoursFirstYear + totalTeachingHoursSecondYear;

      setFields((prevFields) => ({
        ...prevFields,
        teachingHours: totalTeachingHours,
      }));

      return updatedDetails;
    });
  };

  const handleIncomeService = (index, field, value) => {
    setincomeServiceFields((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        [field]: value,
      };
      return updatedDetails;
    });
  };

  useEffect(() => {
    if (checkList?.isFillingWorkvaried) {
      setFields((prevFields) => ({
        ...prevFields,
        overTimeHours: "",
        hoursMertidFilllingTime: "",
      }));
    } else {
      setFields((prevFields) => ({
        ...prevFields,
        overTimeHours: null,
        hoursMertidFilllingTime: null,
      }));
    }
  }, [checkList?.isFillingWorkvaried]);

  useEffect(() => {
    if (checkList?.isEmployeeWithHoliday) {
      setFields((prevFields) => ({
        ...prevFields,
        numberOfPaidHoliday: "",
        holidayPayInKroner: "",
      }));
    } else {
      setFields((prevFields) => ({
        ...prevFields,
        numberOfPaidHoliday: null,
        holidayPayInKroner: null,
      }));
    }
  }, [checkList?.isEmployeeWithHoliday]);

  useEffect(() => {
    if (checkList?.isEmployeeWithLivingWage) {
      setFields((prevFields) => ({
        ...prevFields,
        earnedLivingWage: "",
      }));
    } else {
      setFields((prevFields) => ({
        ...prevFields,
        earnedLivingWage: null,
      }));
    }
  }, [checkList?.isEmployeeWithLivingWage]);

  const handleChange = (name) => (evt) => {
    const { value, type, checked } = evt.target;
    if (
      name === "employmentPeriodFrom" ||
      name === "employmentPeriodEnd" ||
      name === "leaveAbsenceFrom" ||
      name === "leaveAbsenceEnd"
    ) {
      const startDate = new Date(
        name === "employmentPeriodFrom" ? value : fields.employmentPeriodFrom
      );
      const endDate = new Date(
        name === "employmentPeriodEnd" ? value : fields.employmentPeriodEnd
      );
      const leaStartDate = new Date(
        name === "leaveAbsenceFrom" ? value : fields.leaveAbsenceFrom
      );
      const leaEndDate = new Date(
        name === "leaveAbsenceEnd" ? value : fields.leaveAbsenceEnd
      );

      if (
        (name === "employmentPeriodFrom" || name === "employmentPeriodEnd") &&
        fields.employmentPeriodFrom &&
        fields.employmentPeriodEnd &&
        startDate > endDate
      ) {
        return toast.error(
            t("End Date should be greater than Start Date in details of employment")
        );
      }
      if (
        (name === "leaveAbsenceFrom" || name === "leaveAbsenceEnd") &&
        fields.leaveAbsenceFrom &&
        fields.leaveAbsenceEnd &&
        leaStartDate > leaEndDate
      ) {
        return toast.error(
            t("End Date should be greater than Start Date in details of employment")
        );
      }
    }

    if (name === "continueWorkFromDate" || name === "continueWorkEndDate") {
      const contnueStartDate = new Date(
        name === "continueWorkFromDate" ? value : fields.continueWorkFromDate
      );
      const contnueEndtDate = new Date(
        name === "continueWorkEndDate" ? value : fields.continueWorkEndDate
      );
      if (fields?.continueWorkFromDate && fields?.continueWorkEndDate) {
        if (contnueStartDate > contnueEndtDate) {
          return toast.error(
            t("End Date should be greater than Start Date in offer of continued work")
          );
        }
      }
    }

    if (name === "reportedTimeFromDate" || name === "reportedTimeEndDate") {
      const tableStartDate = new Date(
        name === "reportedTimeFromDate" ? value : fields.reportedTimeFromDate
      );
      const tableEndDate = new Date(
        name === "reportedTimeEndDate" ? value : fields.reportedTimeEndDate
      );
      if (tableStartDate > tableEndDate) {
        return toast.error(t("End Date should be greater than Start Date"));
      }
    }

    if (name === "isFullTimehoursPerWeek") {
      setFields((pre) => ({
        ...pre,
        partTimehoursPerWeek: null,
        percentageFullTimeEmployement: null,
      }));
    }
    if (name === "isVaryingHours") {
      setFields((pre) => ({
        ...pre,
        fullTimehoursPerWeek: null,
        partTimehoursPerWeek: null,
        percentageFullTimeEmployement: null,
      }));
    }

    if (name === "isStillEmployed") {
      if (checked) {
        setFields((prevState) => ({
          ...prevState,
          employmentPeriodEnd: null,
          continueWorkFromDate: null,
          continueWorkEndDate: null,
          isContinueEmployeeAcceptedDate: null,
        }));
      } else {
        setFields((prevState) => ({
          ...prevState,
          employmentPeriodEnd: "",
        }));
      }
    } else if (name === "isFullTimehoursPerWeek") {
      if (checked) {
        setFields((prevState) => ({
          ...prevState,
          fullTimehoursPerWeek: "",
        }));
        setcheckList((prevState) => ({
          ...prevState,
          isPartTimehoursPerWeek: false,
          isVaryingHours: false,
        }));
      } else {
        setFields((prevState) => ({
          ...prevState,
          fullTimehoursPerWeek: null,
        }));
      }
    } else if (name === "isPartTimehoursPerWeek" && checked) {
      setFields((prevState) => ({
        ...prevState,
        partTimehoursPerWeek: "",
        percentageFullTimeEmployement: "",
        fullTimehoursPerWeek: null,
      }));
      setcheckList((prevState) => ({
        ...prevState,
        isVaryingHours: false,
        isFullTimehoursPerWeek: false,
      }));
    } else if (name === "isPartTimehoursPerWeek") {
      setFields((prevState) => ({
        ...prevState,
        partTimehoursPerWeek: null,
        percentageFullTimeEmployement: null,
      }));
    } else if (name === "isVaryingHours" && checked) {
      setcheckList((prevState) => ({
        ...prevState,
        isPartTimehoursPerWeek: false,
        isFullTimehoursPerWeek: false,
      }));
    } else if (name === "employeeOwnRequest" && checked) {
      setFields((prevState) => ({
        ...prevState,
        otherReason: null,
      }));
      setcheckList((prevState) => ({
        ...prevState,
        isOtherReason: false,
      }));
    } else if (name === "isOtherReason") {
      setcheckList((prevState) => ({
        ...prevState,
        employeeOwnRequest: false,
      }));
    } else if (name === "isMonthlySalary" && checked) {
      setcheckList((prevState) => ({
        ...prevState,
        isWeeklySalary: false,
        isDalilySalary: false,
        isHourlySalary: false,
      }));
    } else if (name === "isWeeklySalary" && checked) {
      setcheckList((prevState) => ({
        ...prevState,
        isMonthlySalary: false,
        isDalilySalary: false,
        isHourlySalary: false,
      }));
    } else if (name === "isDalilySalary" && checked) {
      setcheckList((prevState) => ({
        ...prevState,
        isMonthlySalary: false,
        isWeeklySalary: false,
        isHourlySalary: false,
      }));
    } else if (name === "isHourlySalary" && checked) {
      setcheckList((prevState) => ({
        ...prevState,
        isMonthlySalary: false,
        isWeeklySalary: false,
        isDalilySalary: false,
      }));
    } else if (
      name === "isMonthlySalary" ||
      name === "isWeeklySalary" ||
      name === "isDalilySalary" ||
      name === "isHourlySalary"
    ) {
      setcheckList((prevState) => ({
        ...prevState,
        [name]: false,
      }));
    }

    if (type === "checkbox") {
      setcheckList((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      let updatedValue = value;
      if (type === "number") {
        const parsedValue = parseFloat(value);
        updatedValue = isNaN(parsedValue) ? "" : parsedValue;
      }
      if (name === "socialSecurityNumber") {
        if (value.length <= 12 || fields[name].length > value.length) {
          setFields((prevState) => ({
            ...prevState,
            [name]: value,
          }));
          setfieldsError((prev) => ({
            ...prev,
            [name + "Error"]: value.length !== 12,
          }));
        }
      } else {
        setFields((prevState) => ({
          ...prevState,
          [name]: updatedValue,
        }));
        setfieldsError((prev) => ({
          ...prev,
          [name + "Error"]: value !== "" ? false : true,
        }));
      }
    }
  };

  const handleNext = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      createEmployerCertificate();
    }
  };

  const resetFields = () => {
    const checkListData = Object.fromEntries(
      Object.keys(checkList)?.map((key) => [key, false])
    );
    const incomeService = incomeServiceFields?.map((item) => {
      const {
        monthdate,
        numberOfDaysWorked,
        dutyHours,
        nOKMonth,
        otherRemunerationEnterArt,
        nOKMonthAmount,
        ...rest
      } = item;
      return {
        monthdate: "",
        numberOfDaysWorked: "",
        dutyHours: "",
        nOKMonth: "",
        otherRemunerationEnterArt: "",
        nOKMonthAmount: "",
        ...rest,
      };
    });
    const firstTable = firstYearDataTable?.map((item) => {
      const {
        month,
        hoursworked,
        absence,
        overtime,
        mertidFillingTime,
        ...rest
      } = item;
      return {
        month,
        hoursworked: "",
        absence: "",
        overtime: "",
        mertidFillingTime: "",
        ...rest,
      };
    });
    const secondTable = secondYearDataTable?.map((item) => {
      const {
        month,
        hoursworked,
        absence,
        overtime,
        mertidFillingTime,
        ...rest
      } = item;
      return {
        month,
        hoursworked: "",
        absence: "",
        overtime: "",
        mertidFillingTime: "",
        ...rest,
      };
    });
    setFields({
      firstName: "",
      lastName: "",
      socialSecurityNumber: "",
      employmentPeriodFrom: "",
      employmentPeriodEnd: "",
      employeePosition: "Freelancer",
      leaveAbsenceFrom: null,
      leaveAbsenceEnd: null,
      extendsIn: null,
      fullTimehoursPerWeek: null,
      partTimehoursPerWeek: null,
      percentageFullTimeEmployement: null,
      otherReason: null,
      continueWorkFromDate: null,
      continueWorkEndDate: null,
      isContinueEmployeeAcceptedDate: null,
      signature: null,
      nameClarification: null,
      reportedTimeFromDate: "",
      reportedTimeEndDate: "",
      teachingHours: "",
      salaryRefers: "",
      amountForOverTime: null,
      overTimeHours: null,
      hoursMertidFilllingTime: null,
      numberOfPaidHoliday: null,
      holidayPayInKroner: null,
      earnedLivingWage: null,
      otherInformation: null,
      employersDate: null,
      userName: "",
      employerName: "Invozio LV SIA",
      streetAddress: "AHTRI 12",
      mailingAddress: "10151 Tallinn",
      organizationNumber: "5020854062",
      telephoneNumber: "010-264 88 10",
      otherInfomationEmployment: null,
      representativeCity: null,
    });
    setincomeServiceFields(incomeService);
    setfirstYearDataTable(firstTable);
    setsecondYearDataTable(secondTable);
    setcheckList(checkListData);
  };

  // Apply Employee Certificate End

  const checkMonthdate = (data) => {
    const hasEmptyMonthdate = data.some((item) => item.monthdate === "");
    if (hasEmptyMonthdate) {
      return "Month Date Can not be Empty in Remuneration taxed";
    }
  };

  const createEmployerCertificate = async () => {
    const getNonNullData = Object.fromEntries(
      Object.entries(fields).filter(([key, value]) => value !== null)
    );
    let checkData = {};
    if (fields) {
      checkData = validate(fields);
    }

    const totalTeachingHoursSecondYear = secondYearDataTable.reduce(
      (acc, item) =>
        acc +
        (parseFloat(item.hoursworked) || 0) +
        (parseFloat(item.absence) || 0) +
        (parseFloat(item.overtime) || 0) +
        (parseFloat(item.mertidFillingTime) || 0),
      0
    );

    if (totalTeachingHoursSecondYear <= 0) {
      delete getNonNullData.reportedTimeEndDate;
    }

    const specificFields = {
      continueWorkFromDate: fields?.continueWorkFromDate,
      continueWorkEndDate: fields?.continueWorkEndDate,
      isContinueEmployeeAcceptedDate: fields?.isContinueEmployeeAcceptedDate,
      salaryRefers: fields?.salaryRefers,
      reportedTimeFromDate: fields?.reportedTimeFromDate,
    };
    
    if (totalTeachingHoursSecondYear > 0) {
      specificFields.reportedTimeEndDate = fields?.reportedTimeEndDate;
    }
    
    if (!checkList?.isStillEmployed && checkList?.isContinueWorkFrom) {
      checkData = validateSpecificDates(specificFields, totalTeachingHoursSecondYear);
    }

    setfieldsError(checkData);

    if (fields?.teachingHours === "")
      return toast.error(t("Please fill in the row data for the table"));

    const hasError = Object.values(checkData).some((value) => value === true);
    if (hasError) {
      return toast.error(t("Form cannot be empty."));
    }

    if (fieldsError?.socialSecurityNumberError) {
      return toast.error(t("SSN number must have 12 digits."));
    }

    if (
      fields?.telephoneNumber?.length < 7 ||
      fields?.telephoneNumber?.length > 15
    ) {
      toast.error(
        t("Phone number should be greater than 10 and less than 12!")
      );
      return;
    }
    if (fields?.extendsIn > 100) {
      return toast.error(t("Extend Percentage should less than 100"));
    }

    const hasNotMonthdate = checkMonthdate(filterTaxServiceIncome);
    if (hasNotMonthdate) return toast.error(t(hasNotMonthdate));

    try {
      setLoading(true);
      const res = await axios.post(`/EmployeeCertificate?lang=${language}`, {
        selectPeriod: orderType === "selected-period" ? true : false,
        individualInvoices: orderType === "individual-invoices" ? true : false,
        // New Value For Employee Certificate
        ...getNonNullData,
        ...checkList,
        EmployeeWagesDetails: filteredData,
        CertificateDetailsPerMonth: filterTaxServiceIncome,
      });
      resetFields();
      if (res.data.response) {
        setLoading(false);
        setOrderType("");
        settoggleCertificate(false);
        toast.success(t("Your Employer certificate has been ordered"));
      }
    } catch (err) {
      if (err?.response?.data?.status === 400) {
        toast.error(t(err?.response?.data?.title));
      }
      setLoading(false);
    }
  };

  const fetchEmployerCertificatePdf = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(`/EmployeeCertificate`);
      setEmployeeCertificate(res.data.response);
      if (res?.data?.statusCode === 200) {
        setisLoading(false);
      }
    } catch (err) {
      setisLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployerCertificatePdf();
  }, []);

  const handlePdfDownload = (certificateId) => {
    const filteredItem = employeeCertificate.find(
      (item) => item.certificateId === certificateId
    );
    fetch(filteredItem.fileContent).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = filteredItem.fileName;
        alink.click();
        toast.success(t("Certificate has been downloaded successfully."));
      });
    });
  };

  const [DownlaodData, setDownlaodData] = useState(null);
  const [toggleDownload, settoggleDownload] = useState(false);
  const handleOpenModal = (certificateData) => {
    setDownlaodData(certificateData);
    settoggleDownload(true);
  };

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="p-4 mt-5 invoice-space2 topspace emp-space"
      showSidebar
      bgcolor
    >
      {loading && <Loader />}
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/employer-certificates"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/arbetsgivarcertifikat"
          />
        )}
      </Helmet>

      <div className="page-content ">
        <div className="employer-certificate">
          <h4 className="accident_ins font-weight-bold">
            {t("Employer certificate")}
          </h4>
          <p>
            <span>{t("emphere")}</span>
          </p>

          <ApplyCertificateForm
            fields={fields}
            checkList={checkList}
            setcheckList={setcheckList}
            handleChange={handleChange}
            setFields={setFields}
            ToggleShow={toggleCertificate}
            Toggleclose={settoggleCertificate}
            submitForCertificate={handleNext}
            fieldsError={fieldsError}
            setfieldsError={setfieldsError}
            // First Table
            firstYearDataTable={firstYearDataTable}
            handlefirstYearDataTableChange={handlefirstYearDataTableChange}
            //Second Table
            handleSecondYearDataTableChange={handleSecondYearDataTableChange}
            secondYearDataTable={secondYearDataTable}
            // Income Service Table
            incomeServiceFields={incomeServiceFields}
            handleIncomeService={handleIncomeService}
            loading={loading}
            resetFields={resetFields}
          />

          <span>
            <div className="date-period-type-input mb-4">
              <input
                className="form-check-input cursor-pointer change_radio_bg"
                type="radio"
                id="date-period-type-workdates"
                name="date-period-type"
                value="selected-period"
                checked={orderType === "selected-period"}
                onChange={(e) => setOrderType(e.target.value)}
              />
              <label className="date-period-type-workdates">
                <span></span>
                <span>
                  {t("Order an employer certificate for the selected period")}
                </span>
              </label>
            </div>

            <button
              className="new_clas_add mb-4"
              type="submit"
              // onClick={handleNext}
              onClick={() => settoggleCertificate(true)}
              disabled={!orderType}
            >
              <span>{t("Orders")}</span>
            </button>
          </span>
          {/* <p className="info mt-3">
            <span>2 {t("Delivery")}</span>
          </p> */}
        </div>

        <DownloadCertificateModal
          toggleDownload={toggleDownload}
          settoggleDownload={settoggleDownload}
          pdfDownloadData={DownlaodData}
          loading={loading}
        />

        <div className="w-100 employer">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>{t("Certificate no")}</th>
                <th>Pdf</th>
                <th>{t("Download")}</th>
              </tr>
            </thead>

            <tbody>
              {employeeCertificate?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item?.certificateId}</td>
                    <td>{item?.fileName || (item?.firstName && "Document")}</td>
                    <td>
                      <Button
                        className="theme_btn"
                        onClick={() => {
                          if (item.fileName) {
                            handlePdfDownload(item.certificateId);
                          } else {
                            handleOpenModal(item);
                          }
                        }}
                      >
                        <FiDownload className="new_colr" size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          {isLoading && (
            <div className="text-center">
              <div
                className="spinner-border text-primary spinner-border-lg"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default EmployerCertificates;
